import { render, staticRenderFns } from "./StudentsList.vue?vue&type=template&id=aba90d46&scoped=true"
import script from "./StudentsList.vue?vue&type=script&lang=js"
export * from "./StudentsList.vue?vue&type=script&lang=js"
import style0 from "./StudentsList.vue?vue&type=style&index=0&id=aba90d46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba90d46",
  null
  
)

export default component.exports